/**
 * Auto-generated file - do not edit by hand
 * Run `pnpm ui:generate:icons` to regenerate
 * Source: source/svg/chevronLeft.svg
 */
import type { IconProps } from '../types';
const ChevronLeft = ({ size, ...props }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    {...props}
  >
    <path
      fill="currentColor"
      d="M13.71 5.262a.9.9 0 0 1 1.273 1.274l-4.969 4.969a8 8 0 0 0-.405.42l-.046.058a.1.1 0 0 0 0 .031q.011.018.046.06c.079.093.197.212.405.42l4.97 4.968.06.069a.9.9 0 0 1-1.265 1.267l-.068-.063-4.97-4.968c-.186-.187-.366-.366-.504-.528a1.9 1.9 0 0 1-.383-.652 1.9 1.9 0 0 1 0-1.175l.077-.193a2.1 2.1 0 0 1 .306-.46c.138-.162.317-.34.505-.528z"
    />
  </svg>
);
export default ChevronLeft;
